import { ForsikringsprodukterPriority } from '../../types/generated-types';
import { ForsikringUnion } from '../../types/internal-types';

export const convertToDate = (dateString: string | Date): Date => new Date(new Date(dateString).toDateString());

export const filterForsikringerBySkadeDato = (forsikringer: ForsikringUnion[], skadedato: Date): ForsikringUnion[] => {
    if (skadedato) {
        return forsikringer.filter((forsikring) => {
            const fromDate = convertToDate(forsikring.periode.from);
            const toDate = convertToDate(forsikring.periode.to);
            return fromDate <= convertToDate(skadedato) && toDate > convertToDate(skadedato);
        });
    }
    return [];
};

export const filterForsikringerByPriority = (
    forsikringer: ForsikringUnion[],
    forsikringsprodukterPriority?: ForsikringsprodukterPriority,
): ForsikringUnion[] => {
    if (
        forsikringsprodukterPriority &&
        forsikringsprodukterPriority.prioritizedForsikringsprodukter.every((forsikringsprodukt) =>
            forsikringer.map((forsikring) => forsikring.produkt).includes(forsikringsprodukt),
        )
    ) {
        return forsikringer.filter(
            (forsikring) =>
                !forsikringsprodukterPriority.excludedForsikringsprodukterIfPrioritizedArePresent.includes(
                    forsikring.produkt,
                ),
        );
    }

    return forsikringer;
};

export const filterForsikringerBySkadeDatoAndPrioritization = (
    forsikringer: ForsikringUnion[],
    skadedato: Date,
    forsikringsprodukterPriority: ForsikringsprodukterPriority | undefined,
): ForsikringUnion[] => {
    const forsikringerActiveOnSkadedato = filterForsikringerBySkadeDato(forsikringer, skadedato);

    return filterForsikringerByPriority(forsikringerActiveOnSkadedato, forsikringsprodukterPriority);
};
